import Base from '@/libs/core/Base'

export const fields = {
  name: '',
  description: '',
  value_chain_uid: '',
}

export default class valueChainOutput extends Base {
  constructor () {
    super(fields)
  }
  
  store () {
    return new Promise(async (resolve, reject) => {
      try {
        let response = await this.form.submit('post', 'silo/value-chain-outputs', this.getFields())
        this.setFields(fields)
        flash(response)
        resolve(response)
      } catch (err) {
        reject(err)
      }
    })
  }
}